import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';

import { cycleRoutes } from './cycle/cycle.routes';
import { deliveryRoutes } from './delivery/delivery.routes';
import { farmerInsightsRoutes } from './farmer-insights/farmer-insights.routes';
import { feedAdviceRoutes } from './feed-advice/feed-advice.routes';
import { productRoutes } from './product/product.routes';
import { referenceSchemeRoutes } from './reference-scheme/reference-scheme.routes';
import { referenceValueSheetRoutes } from './reference-value-sheet/reference-value-sheet.routes';
import { reportRoutes } from './report/report.routes';
import { settingsRoutes } from './settings/settings.routes';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { withinCyclePerformanceRoutes } from './within-cycle-performance/within-cycle-performance.routes';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'cycle',
    pathMatch: 'full',
  },
  ...cycleRoutes,
  ...deliveryRoutes,
  ...productRoutes,
  ...settingsRoutes,
  ...reportRoutes,
  ...farmerInsightsRoutes,
  ...withinCyclePerformanceRoutes,
  ...feedAdviceRoutes,
  ...referenceValueSheetRoutes,
  ...referenceSchemeRoutes,
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },

  // Core lib routes (error pages, not found, etc.)
  ...coreRoutes,
];
